module.exports = __webpack_public_path__ + "img/approval.61617c14.svg";